"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UITag = _interopRequireDefault(require("../../tag/UITag"));

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _default = _react.default.createClass({
  displayName: "MultiSelectValue",
  propTypes: {
    children: _propTypes.default.node,
    closeable: _propTypes.default.bool,
    disabled: _propTypes.default.bool,
    onClick: _propTypes.default.func,
    onRemove: _propTypes.default.func,
    value: _propTypes.default.object
  },
  handleMouseDown: function handleMouseDown(evt) {
    var _this$props = this.props,
        onClick = _this$props.onClick,
        value = _this$props.value;

    if (evt.type === 'mousedown' && evt.button !== 0) {
      return;
    }

    if (onClick) {
      evt.stopPropagation();
      onClick((0, _SyntheticEvent.default)(value));
    }
  },
  handleCloseMouseDown: function handleCloseMouseDown(evt) {
    var _this$props2 = this.props,
        onRemove = _this$props2.onRemove,
        value = _this$props2.value;
    onRemove(value); // Prevent input focus, which leads to scroll jank (#1724)

    evt.preventDefault();
    evt.stopPropagation();
  },
  render: function render() {
    var _this$props3 = this.props,
        children = _this$props3.children,
        closeable = _this$props3.closeable,
        disabled = _this$props3.disabled,
        value = _this$props3.value;
    var computedUse = value.tagUse || 'default';
    return _react.default.createElement(_UITag.default, {
      _onCloseMouseDown: this.handleCloseMouseDown,
      _bordered: true,
      closeable: typeof closeable === 'boolean' ? closeable : !disabled && value.clearableValue !== false,
      onMouseDown: this.handleMouseDown,
      onTouchEnd: this.handleMouseDown,
      use: computedUse
    }, children);
  }
});

exports.default = _default;
module.exports = exports.default;